var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"app-update-notice",attrs:{"to":"/updates","title":"New version available"}},[_c('img',{attrs:{"src":require('@/assets/images/icons/misc/update.png')}})])}
var staticRenderFns = []

export { render, staticRenderFns }